import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DateTime } from 'luxon';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzSegmentedModule } from 'ng-zorro-antd/segmented';
import { NzStatisticModule } from 'ng-zorro-antd/statistic';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { take } from 'rxjs';
import { ToLocaleFormat } from '../../basic/pipes/to-locale-format.pipe';
import { Board } from '../../core/board/board';
import { SessionTemplate } from '../../core/session-template/session-template';
import { SessionTemplateService } from '../../core/session-template/session.template.service';
import { Session, SessionStatus } from '../../core/session/session';
import { SessionService } from '../../core/session/session.service';
import { BoardIconTitleComponent } from '../../domain/board/board-icon-title/board-icon-title.component';
import { SelectablePersonalBoardListComponent } from '../../domain/board/selectable-personal-board-list/selectable-personal-board-list.component';
import { SelectableSessionTemplateListComponent } from '../../domain/session-template/selectable-session-template-list/selectable-session-template-list.component';
import { SessionTemplateCardComponent } from '../../domain/session-template/session-template-card/session-template-card.component';
import { SessionTableComponent } from '../../domain/session/session-table/session-table.component';
import { BasicPageComponent } from '../_shared/basic-page/basic-page.component';

@Component({
  selector: 'app-session',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NzStatisticModule,
    NzButtonModule,
    MatTooltipModule,
    NzAvatarModule,
    NzPopconfirmModule,
    NzIconModule,
    MatTooltipModule,
    NzTableModule,
    NzTagModule,
    NzTabsModule,
    NzSegmentedModule,

    BasicPageComponent,
    ToLocaleFormat,
    BoardIconTitleComponent,
    SessionTableComponent,
    SessionTemplateCardComponent,
    SelectableSessionTemplateListComponent,
    SelectablePersonalBoardListComponent,
  ],
  templateUrl: './session.component.html',
  styleUrl: './session.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SessionComponent {
  SessionStatus = SessionStatus;

  selectedTabIndex = 0;

  recentSessionList = signal<Session[]>([]);
  sessionTemplateSessionList = signal<Session[]>([]);
  memberSessionList = signal<Session[]>([]);

  sessionTemplateList = toSignal(this.sessionTemplateService.itemList$(), { initialValue: [] });

  constructor(
    private sessionService: SessionService,
    private sessionTemplateService: SessionTemplateService
  ) {}

  ngOnInit() {
    this.sessionService.getRecentSessionList$({ weeks: 1 }).subscribe((list) => {
      this.recentSessionList.set(list as Session[]);
    });
  }

  recentOptions = ['One Week', 'One Month', 'Three Months'];
  handleRecentIndexChange(index: number) {
    if (index === 0) {
      this.sessionService.getRecentSessionList$({ weeks: 1 }).subscribe((list) => {
        this.recentSessionList.set(list as Session[]);
      });
    } else if (index === 1) {
      this.sessionService.getRecentSessionList$({ months: 1 }).subscribe((list) => {
        this.recentSessionList.set(list as Session[]);
      });
    } else if (index === 2) {
      this.sessionService.getRecentSessionList$({ months: 3 }).subscribe((list) => {
        this.recentSessionList.set(list as Session[]);
      });
    }
  }

  selectableSessionTemplateList = computed(() => {
    const itemList = this.sessionTemplateList();
    return itemList.map((item) => {
      return {
        isSelected: false,
        item,
      };
    });
  });

  onSessionTemplateListChange(selectableItem: { isSelected: boolean; item: SessionTemplate }) {
    console.log('----- onSessionTemplateListChange');

    if (selectableItem.isSelected) {
      this.sessionService
        .getSessionByTemplateId$([selectableItem.item.id])
        .pipe(take(1))
        .subscribe((newItemList) => {
          console.log('----- newItemList:', newItemList);

          this.sessionTemplateSessionList.update((oldList) => {
            const finalList = [...oldList, ...(newItemList as Session[])];
            finalList.sort((a, b) =>
              (a.createdTime ?? DateTime.local()) < (b.createdTime ?? DateTime.local()) ? 1 : -1
            );

            console.log('----- finalList:', finalList);
            return finalList;
          });
        });
    } else {
      this.sessionTemplateSessionList.update((list) => {
        console.log('----list:', list);

        return list.filter((item) => item.parentId !== selectableItem.item.id);
      });
    }
  }

  onPersonalBoardChange(selectableItem: { isSelected: boolean; item: Board }) {
    if (selectableItem.isSelected) {
    } else {
    }
  }
}
